import React from 'react';

import { Box, Button, Spacer, Typography } from '@bcp-nextgen-dx-component-factory/design-system';
import { ComponentInfo } from '@components';
import { rem } from '@helpers';
import { AccessDenied } from '@icons';

import { useAccessDeniedHelper } from './accessDenied.helper';

export const AccessDeniedPlaceholder: React.FC = () => {
	const { resources, onHandleLeave } = useAccessDeniedHelper();

	return (
		<ComponentInfo
			name="AccessDeniedPlaceholder"
			type="placeholder"
			as={Box}
			styles={{ flexDirection: 'column', alignItems: 'center' }}
		>
			<AccessDenied />
			<Spacer vertical={48} />
			<Box styles={{ flexDirection: 'column', width: rem(416), textAlign: 'center' }}>
				<Typography appearance="body-100-04">{resources.title}</Typography>
				<Spacer vertical={24} />
				<Typography appearance="body-75-02">{resources.subtitle}</Typography>
			</Box>
			<Spacer vertical={32} />
			<Box styles={{ justifyContent: 'center' }}>
				<Button variant="light" appearance="outline" size="medium" onPress={onHandleLeave}>
					{resources.backToHomepage}
				</Button>
			</Box>
		</ComponentInfo>
	);
};
